module.exports = __webpack_public_path__ + "static/media/effort.b4420520.svg";